export const initialStates = {
  addOnProduct: [],
  setAddOnProduct: () => {},
  layoutData: null,
  setAddOnDealProductAdded: () => {},
  dispatchAddOnDealData: () => {}
};
